@use '@css/variables';

.modal
{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(213, 207, 189, 0.7);
  display: flex;
  z-index: 2200;

  padding: 10px;
  overflow: auto;

  .dialog{
    margin: auto;
    max-width: 650px;
    width: 100%;
    border-radius: 6px;
    background-color: white;
    position: relative;
    padding: 20px;

    .close
    {
      position: absolute;
      right: 4px;
      top: 4px;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      color: white;
      background-color: var(--beigedarker);
      padding: 0.5rem 20px 0.5rem;
    }
  }

  footer {
    margin-top: 1em;
    display: flex;
    gap: 1em;
    justify-content: end;
    align-items: end;
  }
}


@media only screen and (min-width: variables.$sm-breakpoint) {

  .modal
  {
    padding: 20px calc(20px + 1em); // modal padding + close button width

    .dialog .close {
      right: -20px;
      top: -20px;
    }
  }
}